import React, { useState } from "react";
import { APIS } from "../../../../utils/api-factory";
import { TenantHeader } from "../../../../utils/apiHeaders";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import {
    loanStatusWiseCountApi, getOveralldashCounts, leadsCountDashBaordApi, getAllFormStatusApi, getAllstateListDistrictByType,
    getLoginToBreApprovalFunnelByDate, getBreApprovalToApprovalFunnelByDate, getApprovalToDisbursalFunnelByDate, getLoginToDisbursalFunnelByDate, getMarketingDetailsByMetricType
} from "../maketingComponents/actioncreator";
import { monthStartDate, todayDate } from "../maketingComponents/utils/utils";
import moment from 'moment';
import Loader from '../../../presentationals/Loader/Loader.component'
import { useEffect } from "react";
import {
    CartesianGrid,
    Line,
    LineChart,
    Tooltip,
    XAxis,
    Label,
    YAxis,
    Legend,
    ResponsiveContainer
} from "recharts";
import Pagination from '@mui/material/Pagination';
import ReactApexChart from "react-apexcharts";
import { error } from "jquery";
const steps = [
    'Basic',
    'Net Approval',
    'More Info',
    'Bank',
    'Document',
    'Loan',
    'Applied'
];
const theme = {
    tickText: "#7c7c7c",
    gridStroke: "rgba(4, 4, 4, 0.4)",
    purpleStroke: "#9747FF",
    yellowStroke: "#FFD54F",
    orangeStroke: "#FFAE89",
    legendColor: "#7c7c7c",
};

const defaultToDate = moment(); // today
const defaultFromDate = moment().subtract(14, 'days');

const size = 10;

const customTabs = [
    { name: "New Leads / New Login", param: "totalPushedCount",subparam:"", clickableKey: "NEW_LEADS",label:"Total Application Counts" },
    { name: "Total Approved But not disbursed", param: "totalApprovedCount",subparam:"", clickableKey: "TOTAL_APPROVED" ,label:"Total Loan Approved"},
    { name: "Rejected Applications", param: "rejectedCount",subparam:"", clickableKey: "REJECTED",label:"BRE Rejected Application" },
    { name: "Disbursed Applications", param: "disbursalCount",subparam:"", clickableKey: "DISBURSED",label:"Total Disbursed" },
    { name: "Additional Credit Review", param: "additionalCreditReview",subparam:"", clickableKey: "ADDITIONAL_CREDIT" ,label:"BRE Additional Credit Review"},
    { name: "Sanction Amount", param: "approvedAmount",subparam:"", clickableKey: "",label:"Total Approved Amount" },
    { name: "Push to All Cloud", param: "totalPushedAllcloud",subparam:"", clickableKey: "PUSH_TO_ALLCLOUD",label:"Contact Creation with All Cloud" },
    { name: "Total Finance Creation", param: "financeAllCloud",subparam:"", clickableKey: "FINANCE_CREATION",label:"Finance Creation on All Cloud" },
    { name: "Total Dealers", param: "communityTypeCounts",subparam:"DEALER", clickableKey: "DEALERS",label:"Total Number of Dealer" },
    { name: "Total AMU Agent", param: "communityTypeCounts",subparam:"AMU_AGENT", clickableKey: "AMU_AGENT",label:"Total Number of AMU Agent" },
    { name: "Total Dealer Agent", param: "communityTypeCounts",subparam:"DEALER_AGENT", clickableKey: "DEALER_AGENT",label:"Total Number of Sales Agent" },
    { name: "Total OEM", param: "oemCounts",subparam:"", clickableKey: "OEM",label:"Total Number of OEM's" },
    { name: "Total CoBorrower", param: "coBorrowerCount",subparam:"", clickableKey: "",label:"Total Number of CoBorrower" },
    { name: "Total Guarantor", param: "guarantorCount",subparam:"", clickableKey: "",label:"Total Number of Guarantor" },
]

const DashboardNew = () => {
    const [stateList, setStateList] = useState([])
    const [districtList, setDistrcitList] = useState([])

    const [nameOpportunity, setNameopportunity] = useState([])
    const [dataOpportunity, setDataopportunity] = useState([])
    const [loader, setLoader] = useState(false)
    const [activeStep, setActiveStep] = useState('');
    const [loginToBreApproval, setLoginToBreApproval] = useState({ name: [], data: [] })
    const [BreApprovalToApproval, setBreApprovalToApproval] = useState({ name: [], data: [] })
    const [ApprovalToDisbursal, setApprovalToDisbursal] = useState({ name: [], data: [] })
    const [LoginToDisbursal, setLoginToDisbursal] = useState({ name: [], data: [] })
    const [ListPopup, setListPopup] = useState({ show: false, key: {} })

    const [dateInput, setdateInput] = useState({
        // fromDate: moment().startOf('month').format('YYYY-MM-DD'),
        // toDate: moment().format('YYYY-MM-DD'),
        // minDate: moment().startOf('month').format('YYYY-MM-DD'),
        fromDate: defaultFromDate.format('YYYY-MM-DD'),
        toDate: defaultToDate.format('YYYY-MM-DD'),
        minDate: defaultFromDate.format('YYYY-MM-DD'),
    });
    const [payload, setPayload] = useState({
        // fromDate: monthStartDate(),
        // toDate: todayDate(),
        // minDate: monthStartDate(),
        fromDate: defaultFromDate.format('DD-MM-YYYY'),
        toDate: defaultToDate.format('DD-MM-YYYY'),
        minDate: defaultFromDate.format('DD-MM-YYYY'),
        state: "", city: "", productType: ""
    });
    const [dashBoardCounts, setDashCounts] = useState({});
    const [dashboardLeadsData, setleadsDashboardData] = useState({});
    const [countData, setCountData] = useState([]);
    const [apexChart, setapexChart] = useState(false);
    const [leadGraph, setleadGraph] = useState(false);

    const getCounts = () => {
        fetch(APIS.GET_OVERALL_DASHBOARD_COUNTS + `${payload.fromDate}&endDate=${payload.toDate}&state=${payload?.state}&city=${payload?.city}&productType=${payload?.productType}`, TenantHeader)
            .then((res) => res.json())
            .then((json) => {
                setDashCounts(json)
            })
            .catch(error => {
                console.log(error);
            })
        // getOveralldashCounts(payload, (callBack) => {
        //     setDashCounts(callBack);
        // });
    };


    const steps = countData.length > 0 ? countData.map((item, index) => ({
        // label: `${item.form_status} (${item.count})`,
        label: `${item.status}`,
        // label: `${item.form_status}`,
        count: `${item.count}`,

        index: index + 1,
    })) : "";

    const handleStepChange = (step) => {
        setActiveStep(step);
    };
    const getformcount = () => {
        // getAllFormStatusApi(
        //     payload,
        //     (callBack) => {
        //         setCountData(callBack);
        //     },
        //     (error) => {
        //         console.log(error);
        //     }
        // );
        fetch(APIS.ALL_APLLICATION_STATS + `${payload.fromDate}&endDate=${payload.toDate}&state=${payload?.state}&city=${payload?.city}&userFlow=${payload?.productType}&userType=BORROWER`)
            .then(res => res.json())
            .then(res => {
                setCountData(res.statusList)
            })
            .catch(error => {
                console.log(error);
            })
    };
    useEffect(() => {
        getCounts()
        leadsCount()
        getdataapi()
        getformcount()
        getAllstateListDistrictByTypeFn()
        getLoginToBreApprovalFunnelByDateFn()
        getBreApprovalToApprovalFunnelByDateFn()
        getApprovalToDisbursalFunnelByDateFn()
        getLoginToDisbursalFunnelByDateFn()
    }, [])
    const leadsCount = () => {
        setLoader(true)
        fetch(APIS.GET_LEADS_COUNT_DASHBOARD_DATA + `${payload.fromDate}&endDate=${payload.toDate}&state=${payload?.state}&city=${payload?.city}&productType=${payload?.productType}`, TenantHeader)
            .then((res) => res.json())
            .then((res) => {
                makegraphDataAadhar(res)
            })
            .finally(() => {
                setLoader(false)
            })
        // leadsCountDashBaordApi(payload, (callBack) => {
        //     makegraphDataAadhar(callBack);
        //     setLoader(false)
        // });
    };
    const getAllstateListDistrictByTypeFn = () => {
        getAllstateListDistrictByType("", callback => {
            setStateList(callback?.data || [])
        })
    }

    const getLoginToBreApprovalFunnelByDateFn = () => {
        getLoginToBreApprovalFunnelByDate(payload?.fromDate, payload?.toDate, payload?.state, payload?.city, payload?.productType, callBack => {
            if (callBack?.status == 200 && callBack?.message == "success") {
                const { name, dataNumber } = getArrayList(callBack?.data)
                setLoginToBreApproval({ name: name || [], data: dataNumber || [] })
            } else {
                setLoginToBreApproval({ name: [], data: [] })
            }
        })
    }
    const getBreApprovalToApprovalFunnelByDateFn = () => {
        getBreApprovalToApprovalFunnelByDate(payload?.fromDate, payload?.toDate, payload?.state, payload?.city, payload?.productType, callBack => {
            if (callBack?.status == 200 && callBack?.message == "success") {
                const { name, dataNumber } = getArrayList(callBack?.data)
                setBreApprovalToApproval({ name: name || [], data: dataNumber || [] })
            } else {
                setBreApprovalToApproval({ name: [], data: [] })
            }
        })
    }
    const getApprovalToDisbursalFunnelByDateFn = () => {
        getApprovalToDisbursalFunnelByDate(payload?.fromDate, payload?.toDate, payload?.state, payload?.city, payload?.productType, callBack => {
            if (callBack?.status == 200 && callBack?.message == "success") {
                const { name, dataNumber } = getArrayList(callBack?.data)
                setApprovalToDisbursal({ name: name || [], data: dataNumber || [] })
            } else {
                setApprovalToDisbursal({ name: [], data: [] })
            }
        })
    }
    const getLoginToDisbursalFunnelByDateFn = () => {
        getLoginToDisbursalFunnelByDate(payload?.fromDate, payload?.toDate, payload?.state, payload?.city, payload?.productType, callBack => {
            if (callBack?.status == 200 && callBack?.message == "success") {
                const { name, dataNumber } = getArrayList(callBack?.data)
                setLoginToDisbursal({ name: name || [], data: dataNumber || [] })
            } else {
                setLoginToDisbursal({ name: [], data: [] })
            }
        })
    }

    const getArrayList = (data) => {
        let name = [];
        let dataNumber = [];
        const newar = Array.isArray(data) ? data : [data]
        for (const item of newar) {
            const { count, status, } = item;

            name.push(status);

            dataNumber.push(count);
        }
        return { name, dataNumber }



    }


    const makegraphDataAadhar = (To) => {
        let data = [];
        Object.entries(To).map((hh, ll) => {
            data.push({
                Date: hh[0],
                Disburse: hh[1].disbursedCount,
                Rejected: hh[1].rejectedCount,
                additionalReviewCount: hh[1].additionalReviewCount,
                Approved: hh[1].approvedCount,
                Total: hh[1].totalCount,
            });
        });

        setleadsDashboardData(data);
    };

    const CustomStepIcon = ({ active, completed, index, data }) => {

        return (
            <div
                style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    backgroundColor: '#064254',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '16px',
                    marginTop: '-16px',
                    // zIndex:'1',
                }}
            >
                {data.count}
                {/* {console.log(active, completed,)} */}
            </div>
        );
    };
    const getdataapi = () => {

        fetch(APIS.GET_LOAN_STATUS_WISE_COUNT_DASHBOARD_DATA + `${payload.fromDate}&endDate=${payload.toDate}&state=${payload?.state}&city=${payload?.city}&productType=${payload?.productType}`, TenantHeader)
            .then((res) => res.json())
            .then((json) => {
                makegraphDataOpportunity(json)
            })
            .catch(error => {
                console.log(error);
            })

    };

    const makegraphDataOpportunity = (To) => {
        let name = [];
        let data = [];

        for (const item of To) {
            const { count, status, } = item;

            name.push(status);

            data.push(count);
        }

        setNameopportunity(name);
        setDataopportunity(data);


    }

    const sortedData = dataOpportunity;
    sortedData.sort((a, b) => b - a);
    const mappedObject = dataOpportunity.reduce((result, key, index) => {
        result[key] = nameOpportunity[index];
        return result;
    }, {});
    var options = {
        series: [{
            data: Object.values(sortedData),
        }],
        chart: {
            type: 'bar',
            height: 350,
        },

        plotOptions: {
            bar: {
                // minBarWidth: 50,
                borderRadius: 0,
                horizontal: true,
                barHeight: '90%',
                isFunnel: true,
                borderRadius: 1,
                orientation: 'vertical',
                radius: 2,
                enableShades: true,
                shadeIntensity: 0.9,
                reverseNegativeShade: true,
                distributed: true,
                useFillColorAsStroke: false,


                colorScale: {
                    ranges: [{
                        from: 0,
                        to: 0,
                        color: undefined,
                        foreColor: undefined,
                        name: undefined,
                    }],
                    inverse: false,
                    min: undefined,
                    max: undefined
                },


            },
        },
        colors: ['#4B49AC', '#7978E9', '#7DA0FA', '#98BDFF', '#98BDFFCC'],
        fill: {
            colors: ['#4B49AC', '#7978E9', '#7DA0FA', '#98BDFF', '#98BDFFCC'],
            opacity: 0.3,
            type: 'gradient',
            gradient: {
                shade: 'light',
                type: "vertical",
                shadeIntensity: 1.8,
                gradientToColors: false,
                inverseColors: false,
                opacityFrom: 0.9,
                opacityTo: 1,
                // stops: series.data,
                colorStops: []
            },
        }, dataLabels: {
            enabled: true,
            formatter: function (val, opt) {
                const opportunityName = nameOpportunity[opt.dataPointIndex];
                return val;
            },
            dropShadow: {
                enabled: true,
            },
        },
        xaxis: {
            categories: nameOpportunity,
        },
        legend: {
            position: 'right',
            show: true,
            markers: {
                fillColors: ['#4B49AC', '#7978E9', '#7DA0FA', '#98BDFF', '#98BDFFCC'],
            },
        },


    };
    const convertedObject = countData.length > 0 ? countData.reduce((result, item) => {
        result[item.form_status] = item.count;
        return result;
    }, {}) : "";

    const closePopup = () => {
        setapexChart(false)
        setleadGraph(false)
    }
    const popupOpen = (type) => {
        if (type === 'apexChart') {
            setapexChart(true)
            setleadGraph(false)

        }
        if (type === 'lead') {
            setapexChart(false)
            setleadGraph(true)

        }

    }

    const handleChange = (e, type) => {
        if (type !== 'applyfilter') {
            const { name, value } = e.target;




            setdateInput({
                ...dateInput,
                [name]: value
            })

            setPayload(prevState => ({
                ...prevState,
                [name]: name == "fromDate" || name == "toDate" ? moment(value).format('DD-MM-YYYY') : value
            }));

            if (name == "state") {
                const ar = stateList?.filter((el) => el?.state == e.target.value)
                setDistrcitList(ar?.[0]?.cities || [])
            }

        } else {
            getCounts()
            leadsCount()
            getdataapi()
            getformcount()
            getLoginToBreApprovalFunnelByDateFn()
            getBreApprovalToApprovalFunnelByDateFn()
            getApprovalToDisbursalFunnelByDateFn()
            getLoginToDisbursalFunnelByDateFn()
        }
    }

    const handleListPopup = (type, data) => {
        if(data?.clickableKey == ""){
             setListPopup({ show: false, key: {} })
        }else{
            setListPopup({ show: type, key: data })
        }
    }
    return (
        <div className="container-fluid">
            {
                loader ?
                    <Loader />
                    : ''}
            {apexChart ?
                <div className="background-blur">
                    <div className='text-right' style={{
                    }}>
                        <i onClick={() => closePopup()} style={{
                            fontSize: '14px', cursor: 'pointer', marginRight: '4.9%',
                            marginTop: '79px',
                            position: 'relative',
                            zIndex: 99,
                            height: '25px',
                            width: '25px',
                            background: 'red',
                            color: '#fff', padding: '4px 7px', borderTopRightRadius: '5px', borderBottomRightRadius: '5px'
                        }} class="fa fa-times" aria-hidden="true"></i>
                    </div>
                    <div className="popup-main small-popup container  " style={{ padding: '20px', borderRadius: '10px', width: '100%', maxHeight: '100%', maxWidth: '90%', overflow: 'scroll', paddingBottom: '100px' }}>
                        <div className=' ' style={{ marginBottom: '20px' }}>

                            <ReactApexChart options={options} series={options.series} type="bar" height={500} width={'100%'} />
                        </div>
                    </div>
                </div>
                : ""}
            {leadGraph ?
                <div className="background-blur">
                    <div className='text-right' style={{
                    }}>
                        <i onClick={() => closePopup()} style={{
                            fontSize: '14px', cursor: 'pointer', marginRight: '4.9%',
                            marginTop: '79px',
                            position: 'relative',
                            zIndex: 99,
                            height: '25px',
                            width: '25px',
                            background: 'red',
                            color: '#fff', padding: '4px 7px', borderTopRightRadius: '5px', borderBottomRightRadius: '5px'
                        }} class="fa fa-times" aria-hidden="true"></i>
                    </div>
                    <div className="popup-main small-popup container  " style={{ padding: '20px', borderRadius: '10px', width: '100%', maxHeight: '100%', maxWidth: '90%', overflow: 'scroll', paddingBottom: '100px' }}>
                        <div className=' ' style={{ marginBottom: '20px' }}>

                            <ResponsiveContainer width={"100%"} height={500}>
                                <LineChart
                                    data={dashboardLeadsData}
                                    margin={{
                                        top: 40,
                                        right: 40,
                                        left: 20,
                                        bottom: 50,
                                    }}
                                >
                                    <CartesianGrid
                                        strokeDasharray={"10 10"}
                                        vertical={false}
                                        stroke={theme.gridStroke}
                                    />
                                    <XAxis
                                        dataKey="Date"

                                        interval={0}
                                        textAnchor="end"
                                        angle={-45}
                                    >

                                    </XAxis>
                                    <YAxis
                                        domain={[0, "dataMax + 0"]}
                                        label={{
                                            value: "Count",
                                            angle: -90,
                                            position: "insideLeft",
                                        }}
                                    />
                                    <Tooltip
                                        wrapperStyle={{ backgroundColor: "#000", fontSize: 12 }}
                                    />

                                    <Line
                                        type="linear"
                                        dataKey="Disburse"
                                        strokeWidth="4"
                                        stroke={theme.purpleStroke}
                                        activeDot={{ r: 5 }}
                                        dot={{
                                            stroke: theme.purpleStroke,
                                            strokeWidth: 4,
                                            fill: theme.purpleStroke,
                                        }}
                                    />
                                    <Line
                                        type="linear"
                                        dataKey="Rejected"
                                        stroke={theme.yellowStroke}
                                        fill="#FFAE89"
                                        strokeWidth="4"
                                        dot={{
                                            stroke: theme.yellowStroke,
                                            strokeWidth: 4,
                                            fill: theme.yellowStroke,
                                        }}
                                        activeDot={{ r: 5 }}
                                    />
                                    <Line
                                        type="linear"
                                        dataKey="additionalReviewCount"
                                        stroke={"#046e69"}
                                        fill="#046e69"
                                        strokeWidth="4"
                                        dot={{
                                            stroke: "#046e69",
                                            strokeWidth: 4,
                                            fill: "#046e69",
                                        }}
                                        activeDot={{ r: 5 }}
                                    />
                                    <Line
                                        type="linear"
                                        dataKey="Approved"
                                        stroke={"#12e80b"}
                                        fill="#12e80b"
                                        strokeWidth="4"
                                        dot={{
                                            stroke: "#12e80b",
                                            strokeWidth: 4,
                                            fill: "#12e80b",
                                        }}
                                        activeDot={{ r: 5 }}
                                    />
                                    <Line
                                        type="linear"
                                        dataKey="Total"
                                        stroke={theme.orangeStroke}
                                        fill="#FFAE89"
                                        strokeWidth="4"
                                        dot={{
                                            stroke: theme.orangeStroke,
                                            strokeWidth: 4,
                                            fill: theme.orangeStroke,
                                        }}
                                        activeDot={{ r: 5 }}
                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
                : ""}
            <div className="container">
                <div className="row" style={{ marginTop: '50px' }}>
                    <div className="col-sm-2 col-xs-12">
                        <div className="inputgrp">
                            <label htmlFor="">From</label>
                            <input type="date" value={dateInput.fromDate} className="form-control" name="fromDate" id="fromDate" onChange={(e) => handleChange(e, 'fromDate')} />
                        </div>
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <div className="inputgrp">
                            <label htmlFor="">To</label>
                            <input type="date" className="form-control" min={dateInput.fromDate} value={dateInput.toDate} name="toDate" id="toDate" onChange={(e) => handleChange(e, 'toDate')} />
                        </div>
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <label htmlFor="">State</label>
                        <select className='form-control' value={payload.state} name="state" onChange={(e) => handleChange(e, "state")}>
                            <option value={""}>Select State</option>
                            {
                                stateList?.length > 0 ? stateList?.map((val, id) => {
                                    return (
                                        <option value={val?.state}>{val?.state}</option>
                                    )
                                })
                                    : ""}
                        </select>
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <label htmlFor="">City</label>
                        <select className='form-control' value={payload.city} name="city" onChange={(e) => handleChange(e, "city")}>
                            <option value={""}>Select City</option>
                            {
                                districtList?.length > 0 ? districtList?.map((val) => {
                                    return (
                                        <option value={val}>{val}</option>
                                    )
                                })
                                    : ""
                            }
                        </select>
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <label htmlFor="">Product type</label>
                        <select className='form-control' value={payload.productType} name="productType" onChange={(e) => handleChange(e, "productType")}>
                            <option value="">Select Product</option>
                            <option value="L3">Three-Wheeler L3</option>
                            <option value="L5">Three-Wheeler L5</option>
                            <option value="BATTERY">BATTERY</option>

                        </select>
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <div className="inputgrp">
                            <button onClick={(e) => handleChange(e, 'applyfilter')} style={{ color: 'rgb(43,120,255)', border: '1px solid rgb(43,120,255)', backgroundColor: '#fff', marginTop: '28px', padding: '10px', borderRadius: '5px' }}>Apply Filter</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container" style={{ marginTop: '50px' }}>


                <div className=" mui-ste" >
                    <div className="shadow" style={{ padding: '10px', paddingBottom: '30px' }}>
                        <h5 style={{ color: '#1D3557' }}><b>Portfolio Summary (Form Stages) &nbsp; </b></h5>
                        <div style={{ overflow: 'auto' }}>
                            <Box sx={{ width: '100%', marginTop: '50px' }}>
                                <Stepper activeStep={activeStep} alternativeLabel >
                                    {steps.length > 0 ? steps.map((step, index) => (
                                        <Step key={step.label} onClick={() => handleStepChange(index)}>
                                            <StepLabel StepIconComponent={(props) => <CustomStepIcon {...props} index={step.index} data={step} />} />
                                            <div className="text-center" style={{ marginTop: '10px' }}>  {step.label === 'NotApproved' ? (
                                                <>
                                                    1<sup>st</sup> Level Rejection
                                                </>
                                            ) : step.label === 'Thanks' ? (
                                                <>
                                                    Complete
                                                </>
                                            ) : (
                                                step.label == "BasicDetails" ? "Basic Details" : step.label == "PermanentAddress" ? "Permanent Address" : step.label == "MobileVerification" ? "Mobile Verification" : step.label == "SoftApproval" ? "Soft Approval" : step.label == "EmploymentDetails" ? "Employment Details" : step.label == "CurrentAddress" ? "Current Address" : step.label == "BankDetails" ? "Bank Details" : step.label == "UploadPhoto" ? "Upload Photo" : step.label == "incomeDetails" ? "Income Details" : step.label == "LoanDetails" ? "Loan Details" : step.label == "AssetsVehicles" ? "Assets Vehicles" : step.label == "InsuranceDetails" ? "Insurance Details" : step.label == "InvoiceDetails" ? "Invoice Details" : step.label == "uploaddocuments" ? "Upload Documents" : step.label == "uploaddocumentspost" ? "Upload Documents Post" : step.label == "addcoborrower" ? "Add Co-Borrower" : step.label == "leads" ? "Leads" : step.label == "fi" ? "FI" : step.label == "esign" ? "E-Sign" : step.label == "addgurantor" ? "Add Guarantor" : step.label == "reference" ? "Reference" : step.label
                                            )}</div>
                                        </Step>
                                    )) : ""}
                                </Stepper>
                            </Box>
                        </div>
                    </div>


                </div>
            </div>

            <div className="container" style={{ marginTop: '50px' }}>


                <div className="row" style={{}}>
                    {
                        customTabs?.length > 0 ? customTabs?.map((val, id) => {
                            return (
                                <div className="col-sm-3 col-xs-12 " style={{ width: "calc(100%/5)", marginTop: id >= 5 ? '30px' : '' }}>
                                    <div className="new-card-market shadow customHover" style={{ height: "130px", cursor: val?.clickableKey !== "" ? 'pointer' : "" }} onClick={() => handleListPopup(true, val)}>
                                        <h4 style={{ color: "#999999" }}>{val?.name}</h4>
                                        <h3 >
                                            <strong>{dashBoardCounts?.[val?.param] !== null && dashBoardCounts?.[val?.param] !== undefined && dashBoardCounts?.[val?.param] !== '' ? val?.subparam !== "" ? Number(dashBoardCounts?.[val?.param]?.[val?.subparam])?.toLocaleString("en-IN") : Number(dashBoardCounts?.[val?.param])?.toLocaleString("en-IN") : 0}</strong>
                                        </h3>
                                    </div>
                                </div>
                            )
                        })
                            : ""}
                </div>


            </div>
            <div className="container" style={{ marginTop: '50px' }}>
                <div className="row" style={{ marginBottom: '40px' }}>
                    <div className="col-sm-6 col-xs-12">
                        <div className="shadow" style={{ padding: '10px' }}>
                            <h5 style={{ color: '#1D3557' }}><b>Application Funnel</b>&nbsp; <span className="fa fa-expand " onClick={() => popupOpen('apexChart')} style={{ cursor: 'pointer', float: 'right' }}></span></h5>
                            <ReactApexChart options={options} series={options.series} type="bar" height={window.innerWidth >= 1900 ? 488 : 300} width={'100%'} />

                        </div>
                    </div>
                    <div className="col-sm-6 col-xs-12">
                        <div className="shadow" style={{ padding: '10px' }}>
                            <h5 style={{ color: '#1D3557' }}><b>Leads Count Graph &nbsp; <span className="fa fa-expand " onClick={() => popupOpen('lead')} style={{ cursor: 'pointer', float: 'right' }}></span></b></h5>

                            <ResponsiveContainer width={"100%"} height={window.innerWidth >= 1900 ? 500 : 315}>
                                <LineChart
                                    data={dashboardLeadsData}
                                    margin={{
                                        top: 40,
                                        right: 40,
                                        left: 20,
                                        bottom: 50,
                                    }}
                                >
                                    <CartesianGrid
                                        strokeDasharray={"10 10"}
                                        vertical={false}
                                        stroke={theme.gridStroke}
                                    />
                                    <XAxis
                                        dataKey="Date"

                                        interval={0}
                                        textAnchor="end"
                                        angle={-45}
                                    >

                                    </XAxis>
                                    <YAxis
                                        domain={[0, "dataMax + 0"]}
                                        label={{
                                            value: "Count",
                                            angle: -90,
                                            position: "insideLeft",
                                        }}
                                    />
                                    <Tooltip
                                        wrapperStyle={{ backgroundColor: "#000", fontSize: 12 }}
                                    />

                                    <Line
                                        type="linear"
                                        dataKey="Disburse"
                                        strokeWidth="4"
                                        stroke={theme.purpleStroke}
                                        activeDot={{ r: 5 }}
                                        dot={{
                                            stroke: theme.purpleStroke,
                                            strokeWidth: 4,
                                            fill: theme.purpleStroke,
                                        }}
                                    />
                                    <Line
                                        type="linear"
                                        dataKey="Rejected"
                                        stroke={theme.yellowStroke}
                                        fill="#FFAE89"
                                        strokeWidth="4"
                                        dot={{
                                            stroke: theme.yellowStroke,
                                            strokeWidth: 4,
                                            fill: theme.yellowStroke,
                                        }}
                                        activeDot={{ r: 5 }}
                                    />
                                    <Line
                                        type="linear"
                                        dataKey="additionalReviewCount"
                                        stroke={"#046e69"}
                                        fill="#046e69"
                                        strokeWidth="4"
                                        dot={{
                                            stroke: "#046e69",
                                            strokeWidth: 4,
                                            fill: "#046e69",
                                        }}
                                        activeDot={{ r: 5 }}
                                    />
                                    <Line
                                        type="linear"
                                        dataKey="Approved"
                                        stroke={"#12e80b"}
                                        fill="#12e80b"
                                        strokeWidth="4"
                                        dot={{
                                            stroke: "#12e80b",
                                            strokeWidth: 4,
                                            fill: "#12e80b",
                                        }}
                                        activeDot={{ r: 5 }}
                                    />
                                    <Line
                                        type="linear"
                                        dataKey="Total"
                                        stroke={theme.orangeStroke}
                                        fill="#FFAE89"
                                        strokeWidth="4"
                                        dot={{
                                            stroke: theme.orangeStroke,
                                            strokeWidth: 4,
                                            fill: theme.orangeStroke,
                                        }}
                                        activeDot={{ r: 5 }}
                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '40px' }}>
                    <div className="col-sm-6 col-xs-12">
                        <FunnelChartComponent
                            title={"Log in to the  BRE Approval"}
                            chartId={"LogInToBreApproval"}
                            // colorsArrayList={['#4B49AC', '#7978E9', '#7DA0FA', '#98BDFF', '#98BDFFCC']}
                            colorsArrayList={['#007B83', '#0097A7', '#26C6DA', '#80DEEA', '#B2EBF2']}
                            sortedDataNumbers={loginToBreApproval?.data} LabelArrayData={loginToBreApproval?.name}
                        />
                    </div>
                    <div className="col-sm-6 col-xs-12">
                        <FunnelChartComponent
                            title={"BRE Approval to Approved"}
                            chartId={"BreApprovalToApproval"}
                            // colorsArrayList={['#4B49AC', '#7978E9', '#7DA0FA', '#98BDFF', '#98BDFFCC']}
                            colorsArrayList={['#2E7D32', '#43A047', '#66BB6A', '#A5D6A7', '#C8E6C9']}
                            sortedDataNumbers={BreApprovalToApproval?.data} LabelArrayData={BreApprovalToApproval?.name}
                        />
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '10px' }}>
                    <div className="col-sm-6 col-xs-12">
                        <FunnelChartComponent
                            title={"Approved to Disbursement"}
                            chartId={"ApprovedToDisbursment"}
                            // colorsArrayList={['#4B49AC', '#7978E9', '#7DA0FA', '#98BDFF', '#98BDFFCC']}
                            colorsArrayList={['#F9A825', '#FBC02D', '#FFD54F', '#FFE082', '#FFF59D']}
                            sortedDataNumbers={ApprovalToDisbursal?.data} LabelArrayData={ApprovalToDisbursal?.name}
                        />
                    </div>
                    <div className="col-sm-6 col-xs-12">
                        <FunnelChartComponent
                            title={"Log in to Disbursal"}
                            chartId={"LoginToDisbursal"}
                            // colorsArrayList={['#4B49AC', '#7978E9', '#7DA0FA', '#98BDFF', '#98BDFFCC']}
                            colorsArrayList={['#1565C0', '#1E88E5', '#42A5F5', '#81D4FA', '#B3E5FC']}
                            sortedDataNumbers={LoginToDisbursal?.data} LabelArrayData={LoginToDisbursal?.name}
                        />
                    </div>
                </div>
            </div>

            {
                ListPopup?.show ?
                    <CustomPopup
                        customTabs={customTabs}
                        closepopup={handleListPopup}
                        selectedItem={ListPopup?.key}
                        setLoader={setLoader} payload={payload}
                    />
                    : ""}

        </div >
    )
}
export default DashboardNew


const FunnelChartComponent = ({ title, chartId, sortedDataNumbers, colorsArrayList, LabelArrayData }) => {
    const [popupOpen, setpopupOpen] = useState({ type: "", show: false })
    var options = {
        series: [{
            data: sortedDataNumbers?.length > 0 ? Object.values(sortedDataNumbers) : [],
        }],
        chart: {
            type: 'bar',
            height: 350,
        },

        plotOptions: {
            bar: {
                // minBarWidth: 50,
                borderRadius: 0,
                horizontal: true,
                barHeight: '90%',
                isFunnel: true,
                borderRadius: 1,
                orientation: 'vertical',
                radius: 2,
                enableShades: true,
                shadeIntensity: 0.9,
                reverseNegativeShade: true,
                distributed: true,
                useFillColorAsStroke: false,


                colorScale: {
                    ranges: [{
                        from: 0,
                        to: 0,
                        color: undefined,
                        foreColor: undefined,
                        name: undefined,
                    }],
                    inverse: false,
                    min: undefined,
                    max: undefined
                },


            },
        },
        colors: colorsArrayList,
        fill: {
            colors: colorsArrayList,
            opacity: 0.3,
            type: 'gradient',
            gradient: {
                shade: 'light',
                type: "vertical",
                shadeIntensity: 1.8,
                gradientToColors: false,
                inverseColors: false,
                opacityFrom: 0.9,
                opacityTo: 1,
                // stops: series.data,
                colorStops: []
            },
        }, dataLabels: {
            enabled: true,
            formatter: function (val, opt) {
                const opportunityName = LabelArrayData[opt.dataPointIndex];
                return val;
            },
            dropShadow: {
                enabled: true,
            },
        },
        xaxis: {
            categories: LabelArrayData,
        },
        legend: {
            position: 'right',
            show: true,
            markers: {
                fillColors: colorsArrayList,
            },
        },


    };
    return (
        <>
            {popupOpen?.show ?
                <div className="background-blur">
                    <div className='text-right' style={{
                    }}>
                        <i onClick={() => setpopupOpen({ type: "", show: false })} style={{
                            fontSize: '14px', cursor: 'pointer', marginRight: '4.9%',
                            marginTop: '79px',
                            position: 'relative',
                            zIndex: 99,
                            height: '25px',
                            width: '25px',
                            background: 'red',
                            color: '#fff', padding: '4px 7px', borderTopRightRadius: '5px', borderBottomRightRadius: '5px'
                        }} class="fa fa-times" aria-hidden="true"></i>
                    </div>
                    <div className="popup-main small-popup container  " style={{ padding: '20px', borderRadius: '10px', width: '100%', maxHeight: '100%', maxWidth: '90%', overflow: 'scroll', paddingBottom: '100px' }}>
                        <div className=' ' style={{ marginBottom: '20px' }}>

                            <ReactApexChart options={options} series={options.series} type="bar" height={500} width={'100%'} />
                        </div>
                    </div>
                </div>
                : ""}
            <div className="shadow" style={{ padding: '10px' }}>
                <h5 style={{ color: '#1D3557' }}><b>{title}</b>&nbsp; <span className="fa fa-expand " onClick={() => setpopupOpen({ type: chartId, show: true })} style={{ cursor: 'pointer', float: 'right' }}></span></h5>
                <ReactApexChart options={options} series={options.series} type="bar" height={window.innerWidth >= 1900 ? 488 : 300} width={'100%'} />

            </div>
        </>
    )
}


const CustomPopup = ({ customTabs, closepopup, selectedItem, setLoader, payload }) => {
    const [data, setData] = useState([])
    const [currentPage, setCurrentPage] = useState(0)
    const [totalPage, setTotalPage] = useState(0)

    const handlePageChange = (event, value) => {
        setCurrentPage(value - 1)
        fn(value - 1)
    }

    useEffect(() => {
        fn(0)
    }, [selectedItem?.name])

    const fn = (val) => {
        setLoader(true)
        getMarketingDetailsByMetricType(selectedItem?.clickableKey, payload?.fromDate, payload?.toDate, val, size,payload?.state,payload?.city, payload?.productType, callback => {
            console.log("call", callback)
            setData(callback?.data?.data || [])
            setTotalPage(callback?.data?.totalPages ?? 0)
            setLoader(false)
        })
    }

    return (
        <>
            <div className="background-blur">

                <div className="popup-main  container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', height: 'auto' }}>
                    <i onClick={() => closepopup(false, {})} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                    <div className="row from-group">
                        <div className="col-xs-12" style={{ padding: '10px' }}>
                            <h4 className="text-center" style={{ marginBottom: '10px', marginTop: '10px' }}>{selectedItem?.name} Details - ({selectedItem?.label})</h4>

                            <div className="other-table" style={{ marginTop: '30px' }}>
                                <div className='' style={{ fontSize: '12px', overflow: 'auto', marginRight: 'auto' }} >
                                    <table className="table" style={{ borderCollapse: 'collapse', borderSpacing: '0' }}>
                                        {
                                            selectedItem?.clickableKey == "OEM" ?
                                                <thead style={{ background: 'rgba(0, 108, 103, 0.2)', color: '#000', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                                                    <tr className="thead-class">
                                                        <th>
                                                            <b>OEM Id</b>
                                                        </th>
                                                        <th>
                                                            <b>Make</b>
                                                        </th>
                                                        <th>
                                                            <b>Make Class</b>
                                                        </th>
                                                        <th>
                                                            <b>Model</b>
                                                        </th>
                                                        <th>
                                                            <b>Vehicle Type</b>
                                                        </th>
                                                        <th>
                                                            <b>Variant</b>
                                                        </th>

                                                    </tr>
                                                </thead>
                                                :
                                                selectedItem?.clickableKey == "DEALERS" ||   selectedItem?.clickableKey == "AMU_AGENT" || selectedItem?.clickableKey == "DEALER_AGENT" ?
                                                    <thead style={{ background: 'rgba(0, 108, 103, 0.2)', color: '#000', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                                                        <tr className="thead-class">
                                                            <th>
                                                                <b>Community Name</b>
                                                            </th>
                                                            <th>
                                                                <b>Community Type</b>
                                                            </th>
                                                            <th>
                                                                <b>State</b>
                                                            </th>
                                                            <th>
                                                                <b>City</b>
                                                            </th>
                                                            <th>
                                                                <b>Added On</b>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    :
                                                    <thead style={{ background: 'rgba(0, 108, 103, 0.2)', color: '#000', borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                                                        <tr className="thead-class">
                                                            <th>
                                                                <b>Full Name</b>
                                                            </th>
                                                            <th>
                                                                <b>Email Id</b>
                                                            </th>
                                                            <th>
                                                                <b>Mobile Number</b>
                                                            </th>
                                                            <th>
                                                                <b>User Flow</b>
                                                            </th>
                                                            <th>
                                                                <b>Loan Approve Amount</b>
                                                            </th>
                                                            <th>
                                                                <b>Loan Apply Date</b>
                                                            </th>
                                                            <th>
                                                                <b>Loan Status</b>
                                                            </th>
                                                            <th>
                                                                <b>BRE Decision</b>
                                                            </th>
                                                            <th>
                                                                <b>Rejection Reason</b>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                        }
                                        {data?.length > 0 ?
                                            <tbody style={{ height: '350px', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
                                                {data?.map((data1, i) => {

                                                    return (
                                                        <>
                                                            {selectedItem?.clickableKey == "OEM" ?
                                                                <tr style={{ borderBottom: "none", fontWeight: '400' }} key={i}>
                                                                    <td>
                                                                        {data1?.oemId || "-"}
                                                                    </td>
                                                                    <td>
                                                                        {data1?.make || "-"}
                                                                    </td>
                                                                    <td>
                                                                        {data1?.makeClass || "-"}
                                                                    </td>
                                                                    <td>
                                                                        {data1?.model || "-"}
                                                                    </td>
                                                                    <td>
                                                                        {data1?.vehicleType || "-"}
                                                                    </td>
                                                                    <td>
                                                                        {data1?.variant || "-"}
                                                                    </td>


                                                                </tr>
                                                                :
                                                                  
                                                selectedItem?.clickableKey == "DEALERS" ||   selectedItem?.clickableKey == "AMU_AGENT" || selectedItem?.clickableKey == "DEALER_AGENT" ?
                                                 <tr style={{ borderBottom: "none", fontWeight: '400' }} key={i}>
                                                                    <td>
                                                                        {data1?.communityName || "-"}
                                                                    </td>
                                                                    <td>
                                                                        {data1?.communityType || "-"}
                                                                    </td>
                                                                    <td>
                                                                        {data1?.state || "-"}
                                                                    </td>
                                                                    <td>
                                                                        {data1?.city || "-"}
                                                                    </td>
                                                                    <td>
                                                                        {data1?.addedOn || "-"}
                                                                    </td>
                                                                  


                                                                </tr>
                                                                :
                                                                <tr style={{ borderBottom: "none", fontWeight: '400' }} key={i}>
                                                                    <td>
                                                                        {data1?.fullName || "-"}
                                                                    </td>
                                                                    <td>
                                                                        {data1?.email || "-"}
                                                                    </td>
                                                                    <td>
                                                                        {data1?.mobileNo || "-"}
                                                                    </td>
                                                                    <td>
                                                                        {data1?.userFlow || "-"}
                                                                    </td>
                                                                    <td>
                                                                        {data1?.loanApproveAmount || "-"}
                                                                    </td>
                                                                    <td>
                                                                        {data1?.loanApplyDate || "-"}
                                                                    </td>
                                                                    <td>
                                                                        {data1?.loanStatus || "-"}
                                                                    </td>
                                                                    <td>
                                                                        {data1?.breDecision || "-"}
                                                                    </td>
                                                                    <td>
                                                                        {data1?.rejectionReason || "-"}
                                                                    </td>

                                                                </tr>
                                                            }
                                                        </>
                                                    )

                                                })}

                                            </tbody>
                                            :
                                            ""
                                        }
                                    </table>
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'end' }}>
                                <Pagination
                                    count={Math.ceil(totalPage)}
                                    page={currentPage + 1}
                                    onChange={handlePageChange}
                                    color="success"
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}